import { config } from '@services/config';
import { ContactInfoGetResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCustomerContactInfo = (customerId: string) => {
  const client = useClient();
  const result = useQuery<ContactInfoGetResponse, Error>({
    queryKey: customerQueryKey.searchContactInfo({ customerId }),
    queryFn: () => client.get(`customer/${customerId}/contact-info`).json<ContactInfoGetResponse>(),
    enabled: !!customerId && customerId !== '',
    refetchOnWindowFocus: false,
    ...config,
  });
  return { ...result, contactInfo: result.data };
};
